import React from 'react';

export const InputDescription: React.FC<{ description?: string }> = ({
  description
}) => {
  return description ? <p className="form-element-description">{description}</p> : null;
};
